import { LocationResponseV1, LocationSearchResponseV1 } from '@forto-dev/locations-models'

import Client from '@/api/client'
import { getConfig } from '@/app/config'

export const createLocationsService = (locationsClient: Client) => ({
  searchLocation: (searchText: string) =>
    locationsClient.get<LocationSearchResponseV1>(`/v1/locations`, { params: { search: searchText } }),
  getLocationDetail: (locationRef: string) => locationsClient.get<LocationResponseV1>(`/v1/locations/${locationRef}`),
})

export const { searchLocation, getLocationDetail } = createLocationsService(
  new Client(`${getConfig().API_ENDPOINT ?? ''}/api/locations`)
)
